<template>
<Admin style="background: #f2f2f2;">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl detail-company tw-min-h-80">
          <v-card-text>
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true">
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <div class="tw-mt-5 tw-mx-5 tw-font-bold tw-text-xl">{{ companyDetail.nameTH }}</div>
            <div class="tw-mx-5  tw-text-base">{{ companyDetail.nameEN }}</div>

            <v-row class="row-wrapper tw-mt-7">
              <v-col cols="12" md="2">
                <v-avatar size="170" color="#F5F5F5" class="mr-3 font-24 logoText" style="background-color: #fff;">
                  <img v-if="companyDetail.imageLogoUrl"
                       :src="companyDetail.imageLogoUrl + '=s' + Math.round(200 * getDeviceRatio())"
                       :alt="companyDetail.nameTH" style="object-fit: contain;">
                  <span v-else-if="companyDetail.nameEN"
                        class="edit-text-avatar">{{ companyDetail.nameEN[0].toUpperCase() }}</span>
                  <span v-else/>
                  <v-progress-circular
                    v-if="loading"
                    :width="3"
                    indeterminate
                    color="green"
                  ></v-progress-circular>
                </v-avatar>
              </v-col>
              <v-col cols="12" md="10">
                <v-row>
                  <v-col cols="12" md="2" class="text-title-company">เลขประจำตัวผู้เสียภาษี:</v-col>
                  <v-col cols="12" md="10" class="text-detail-company">{{companyDetail.taxID}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="2" class="text-title-company">สาขา:</v-col>
                  <v-col cols="12" md="10" class="text-detail-company">-</v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="2" class="text-title-company">ข้อมูลบริษัท:</v-col>
                  <v-col cols="12" md="10" class="text-detail-company">{{ getAddress(companyDetail.address) }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="2" class="text-title-company">เบอร์โทรศัพท์:</v-col>
                  <v-col cols="12" md="10" class="text-detail-company">{{companyDetail.phoneNumber}}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from '../../components/admin/admin-main-template'
import {mapState} from "vuex";

const _ = require('lodash')

export default {
  name: "settingCompanyDetail",
  components: {
    Admin
  },
  computed: mapState({
    companyDetail:state => state.companies.companyDetail,
    loading:state => state.companies.loading,
  }),
  data: () => ({
    items: [
      {
        text: 'ตั้งค่า',
        disabled: false,
        to: {name: 'Company.Settings'},
      },
      {
        text: 'โปรไฟล์บริษัท',
        disabled: false,
        to: {name: 'Company.Settings.Company'},
      },
    ],
  }),
  created() {
    let companyDetailId = this.$route.params.companyDetailId
    this.$store.dispatch('companies/getCompany', {companyID: companyDetailId})
  },
  destroyed() {
    this.$store.dispatch('companies/setEmptyCompanyDetail')
  },
  methods:{
     getAddress: function (address) {
      let showAddress = ""
      if (!address) {
        return showAddress
      }
      if (address.addressNo) {
        showAddress += `เลขที่ ${address.addressNo}`
      }
      if (address.building) {
        showAddress += ` ${address.building}`
      }
      if (address.alley) {
        showAddress += ` ซอย ${address.alley}`
      }
      if (address.village) {
        showAddress += ` หมู่ที่ ${address.village}`
      }
      if (address.street) {
        showAddress += ` ถนน${address.street}`
      }
      if (address.subDistrict) {
        showAddress += ` แขวง${address.subDistrict}`
      }
      if (address.district) {
        showAddress += ` เขต${address.district}`
      }
      if (address.province) {
        showAddress += ` ${address.province}`
      }
      if (address.postCode) {
        showAddress += ` ${address.postCode}`
      }
      return showAddress
    },
    getDeviceRatio() {
      return window.devicePixelRatio
    },
  },
  watch:{
    companyDetail: {
      handler: function (){
        if (this.companyDetail) {
          let tmpItems = _.cloneDeep(this.items)
          tmpItems.push({ text: this.companyDetail.nameTH , disabled: true})
          this.items = tmpItems;
        }
      }
    }
  }
}
</script>

<style lang="scss">
.row-wrapper{
  padding-left: 20px;
}
.text-title-company{
  font-size: 16px;
  font-weight: bold;
  color: #191919;
}
.text-detail-company{
  font-size: 16px;
  color: #191919;
}
.detail-company{
  min-height: 500px;
}
</style>
